import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { ReactComponent as CheckIcon } from 'assets/images/svg/checkmark.svg';

import siteStyle from 'utils/siteStyle';

const Input = ({
  id,
  label,
  containerClassName,
  inputClassName,
  labelClassName,
  type,
  placeholder,
  handleChange,
  handleBlur,
  handleFocus,
  disabled,
  name,
  value,
  error,
  touched,
  locked,
  leftIcon,
  togglePassword,
  showOkTick,
  errorClassname,
}) => (
  <div className={containerClassName}>
    {label && (
      <div className={classnames('mb-2 font-primary-two text-3 tracking-0 leading-none text-dark', labelClassName)}>
        <label htmlFor={id}>
          {label}
        </label>
      </div>
    )}
    <div className="relative">
      {leftIcon && (
        <div className="flex items-center h-full absolute pl-2">
          {leftIcon?.custom ? leftIcon.custom
            : <img src={leftIcon.src} alt={leftIcon.alt} className={leftIcon.className} />}
        </div>
      )}
      <input
        id={id}
        type={type}
        className={classnames({
          'base-input-styles focus:outline-none bg-white placeholder-light-grey-four': true,
          'border-light-grey-four': !error || !touched,
          'border-special-red': !!error && touched,
          'text-dark text-opacity-50': locked,
          'cursor-not-allowed': disabled || locked,
        }, siteStyle({ gd: 'rounded-none' }), inputClassName)}
        onChange={handleChange}
        onBlur={handleBlur}
        onFocus={handleFocus}
        value={value}
        name={name}
        placeholder={placeholder}
        aria-label={label}
        disabled={disabled || locked}
      />
      <div className="absolute top-0 bottom-0 flex items-center gap-4 right-4">
        {togglePassword && (
          <button type="button" onClick={togglePassword} className="leading-8 bg-transparent border-none font-primary-two text-3.5 text-dark -tracking-0.2 focus:outline-none">
            {type === 'password' ? 'Show' : 'Hide'}
          </button>
        )}
        {showOkTick && (
          <div className="">
            <CheckIcon className="w-3 h-3 fill-current text-shamrock ok-icon" />
          </div>
        )}
      </div>
    </div>
    { touched && error && (
      <div className={classnames('font-primary-two -tracking-0.2 text-special-red', errorClassname)}>
        {error}
      </div>
    )}
  </div>
);

Input.defaultProps = {
  label: null,
  containerClassName: 'w-full',
  inputClassName: '',
  labelClassName: '',
  type: 'text',
  placeholder: '',
  handleChange: null,
  handleBlur: null,
  handleFocus: null,
  disabled: false,
  name: null,
  value: '',
  error: '',
  touched: false,
  locked: false,
  leftIcon: null,
  togglePassword: null,
  showOkTick: false,
  errorClassname: 'mt-2 text-3 leading-3',
};

Input.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  containerClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  handleFocus: PropTypes.func,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  touched: PropTypes.bool,
  locked: PropTypes.bool,
  leftIcon: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string,
    custom: PropTypes.node,
    className: PropTypes.string,
  }),
  togglePassword: PropTypes.func,
  showOkTick: PropTypes.bool,
  errorClassname: PropTypes.string,
};

export default Input;
